import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API = 'https://khepri.tech/api/v1';

function Brief() {
  const [data, setData] = useState(null);
  const [overdraftStatus, setOverdraftStatus] = useState('');
  const [demoRisk, setDemoRisk] = useState(false);
  const [doneTasks, setDoneTasks] = useState([]);
  const token = localStorage.getItem('khepri_token');
  const navigate = useNavigate();

  useEffect(() => {
    fetch(API + '/khepri/brief', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(d => {
        setData(d);
        setDoneTasks((d.tasks || []).filter(t => t.done).map(t => t.id));
      });
  }, [token]);

  const requestOverdraft = () => {
    setOverdraftStatus('pending');
    setTimeout(() => {
      setOverdraftStatus('approved');
    }, 2000);
  };

  const toggleTask = async (taskId) => {
    setDoneTasks(prev => prev.includes(taskId) ? prev.filter(t => t !== taskId) : [...prev, taskId]);
    try {
      await fetch(API + `/tasks/${taskId}/done`, { method: 'POST' });
    } catch (err) {
      console.error('Task update error:', err);
    }
  };

  const hasRisk = data?.has_risk || demoRisk;
  const hasWarning = !hasRisk && (data?.balance || 0) < 100000;

  if (!data) return <p style={{color:'#94A3B8'}}>Загрузка...</p>;

  const forecast = data.forecast_14d || [];
  const minBalance = Math.min(...forecast.map(p => p.balance), 0);
  const maxBalance = Math.max(...forecast.map(p => p.balance), 1);
  const range = maxBalance - minBalance || 1;

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h2 style={{ color: '#F7DE8A', marginBottom: 4 }}>{data.greeting || 'Добрый день'}</h2>
          <p style={{ color: '#94A3B8', fontSize: 13 }}>Ваш бизнес — под контролем</p>
        </div>
        <button
          onClick={() => { setDemoRisk(!demoRisk); setOverdraftStatus(''); }}
          style={{
            padding: '6px 14px',
            background: demoRisk ? '#EF4444' : '#334155',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {demoRisk ? '🟢 Скрыть демо' : '🔴 Демо: Кассовый разрыв'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Баланс</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#F7DE8A' }}>{(data.balance || 0).toLocaleString()} РУБ</div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Прогноз</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: hasRisk ? '#EF4444' : hasWarning ? '#F59E0B' : '#10B981' }}>
            {hasRisk ? 'РИСК' : hasWarning ? 'ВНИМАНИЕ' : 'НОРМА'}
          </div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Ближайший платёж</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#F7DE8A' }}>{(data.upcoming_tax_events || [])[0]?.name?.slice(0, 15) || 'Нет'}</div>
        </div>
      </div>

      {/* Быстрые действия */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
        <button onClick={() => navigate('/accounting')} style={{ padding: 12, background: '#F7DE8A', border: 'none', borderRadius: 8, color: '#0F172A', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
          💰 Оплатить налог
        </button>
        <button onClick={() => navigate('/contracts')} style={{ padding: 12, background: '#1E293B', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          📄 Создать договор
        </button>
        <button onClick={() => navigate('/counterparty')} style={{ padding: 12, background: '#1E293B', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          🔍 Проверить контрагента
        </button>
        <button onClick={() => navigate('/bankaccounts')} style={{ padding: 12, background: '#1E293B', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          🏦 Открыть счёт
        </button>
      </div>

      {hasWarning && !hasRisk && (
        <div style={{ marginBottom: 20, padding: 16, background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: 12 }}>
          <strong style={{ color: '#F59E0B' }}>⚠️ Низкий баланс</strong>
          <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4 }}>
            Баланс ниже 100 000 ₽. Рекомендуем проверить предстоящие платежи и пополнить счёт.
          </p>
          <button onClick={() => navigate('/bankaccounts')} style={{ marginTop: 10, padding: '8px 16px', background: 'rgba(245,158,11,0.2)', color: '#F59E0B', border: '1px solid rgba(245,158,11,0.3)', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
            Открыть счёт →
          </button>
        </div>
      )}

      {hasRisk && (
        <div style={{ marginBottom: 20, padding: 16, background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <div>
              <strong style={{ color: '#EF4444' }}>⚠️ Обнаружен кассовый разрыв!</strong>
              <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4 }}>
                {data.red_days > 0 ? `Кассовый разрыв через ${data.red_days} дн. Баланс будет отрицательным.` : 'Баланс низкий. Рекомендуем оформить овердрафт.'}
              </p>
            </div>
            <button onClick={requestOverdraft} disabled={overdraftStatus === 'pending' || overdraftStatus === 'approved'} style={{ padding: '10px 20px', background: overdraftStatus === 'approved' ? '#10B981' : overdraftStatus === 'pending' ? '#F59E0B' : '#F7DE8A', color: overdraftStatus === 'approved' ? '#fff' : '#0F172A', border: 'none', borderRadius: 8, cursor: overdraftStatus === 'approved' ? 'default' : 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}>
              {overdraftStatus === 'approved' ? '✓ Овердрафт одобрен (200 000 ₽)' : overdraftStatus === 'pending' ? 'Обработка...' : 'Запросить овердрафт'}
            </button>
          </div>
        </div>
      )}

      <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <h3 style={{ marginBottom: 12, color: '#F7DE8A' }}>📈 График баланса</h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 120 }}>
          {forecast.map((p, i) => {
            const height = ((p.balance - minBalance) / range) * 100;
            return (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
                <div style={{ width: '100%', height: `${Math.max(height, 2)}%`, background: p.risk === 'red' ? '#EF4444' : p.risk === 'yellow' ? '#F59E0B' : '#F7DE8A', borderRadius: 4 }} title={`${p.date}: ${Math.round(p.balance).toLocaleString()} ₽`} />
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8, fontSize: 10, color: '#94A3B8' }}>
          <span>{forecast[0]?.date?.slice(5)}</span>
          <span>{forecast[6]?.date?.slice(5)}</span>
          <span>{forecast[13]?.date?.slice(5)}</span>
        </div>
      </div>

      <h3 style={{ marginBottom: 10, color: '#F7DE8A' }}>Задачи</h3>
      {(data.tasks || []).map(t => {
        const done = t.done || doneTasks.includes(t.id);
        return (
          <div key={t.id} onClick={() => toggleTask(t.id)} style={{ padding: 10, marginBottom: 6, background: '#1E293B', borderRadius: 8, borderLeft: '3px solid ' + (t.priority === 'critical' ? '#EF4444' : t.priority === 'high' ? '#F59E0B' : '#F7DE8A'), fontSize: 13, cursor: 'pointer', opacity: done ? 0.5 : 1 }}>
            <span style={{ marginRight: 8 }}>{done ? '✅' : '⬜'}</span>
            <span style={{ textDecoration: done ? 'line-through' : 'none' }}>{t.text}</span>
          </div>
        );
      })}

      <h3 style={{ marginTop: 20, marginBottom: 10, color: '#F7DE8A' }}>Прогноз на 14 дней</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <thead><tr style={{ color: '#94A3B8' }}><th>Дата</th><th>Баланс</th><th>Приход</th><th>Расход</th><th>Риск</th></tr></thead>
        <tbody>
          {forecast.slice(0, 14).map((p, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #8A6636' }}>
              <td style={{ padding: 4 }}>{p.date?.slice(5)}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#F7DE8A' }}>{Math.round(p.balance).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#10B981' }}>+{Math.round(p.income).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#EF4444' }}>-{Math.round(p.expense).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'center' }}>{p.risk === 'red' ? '🔴' : p.risk === 'yellow' ? '🟡' : '🟢'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Brief;